import api from './api';
import { IdentitySnapshot } from '../models/Chatwoot/Identity';
import { getBackVersion } from '../config';

const getIdentityHash = (): Promise<IdentitySnapshot> =>
    api.request<IdentitySnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/chatwoot/identity`,
    });

export default { getIdentityHash };
